import { ShoesState } from 'src/types'

export const heels = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.healReinforcement.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(548, 488) //つま先＿左下
  ctx.quadraticCurveTo(725, 497, 846, 495)
  ctx.quadraticCurveTo(879, 420, 843, 336)
  ctx.quadraticCurveTo(843, 322, 843, 322)
  ctx.quadraticCurveTo(695, 355, 548, 488)
  //   ctx.quadraticCurveTo(0, 0, 0, 0)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = 'white'
  ctx.lineWidth = 2.5
  ctx.beginPath()
  ctx.moveTo(548, 489)
  ctx.quadraticCurveTo(686, 363, 843, 323)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(557, 488) // 左
  ctx.quadraticCurveTo(700, 360, 841, 331)
  ctx.moveTo(560, 488) // 左
  ctx.quadraticCurveTo(705, 366, 843, 334)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
  //   canvasResetter(ctx) // リセット
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()
